import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChatGptUtilityMappingService extends BaseService {
  constructor() {
    super(constants.GET_CHATGPT_MAPPING_DATA, 'chatgptUtilityMappingStatus');
  }

  handleEvent(eventName, event) {
    return this.getClient('evergreen').post(`/chatutility/contentTOC/getData/${event.payload.bookId}`, {});
    // return this.getClient('evergreen').post(`/chatutility/contentTOC/getData/103313`, {});
  }

  handleResponse(response) {
    const { data, status } = response;
    if (status === 200) {
      Framework.getStoreRegistry().getStore('chatgptMappingUtility').setResponse(data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    // Framework.getStoreRegistry().getStore('chatgptUtility').resetStoreValues();
  }
}
